import { render, staticRenderFns } from "./PromoteToAdminButton.vue?vue&type=template&id=69d8539c&scoped=true"
import script from "./PromoteToAdminButton.vue?vue&type=script&lang=ts"
export * from "./PromoteToAdminButton.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69d8539c",
  null
  
)

export default component.exports